import React from "react";
import SelectService from "../../components/SelectService";

const Server4 = () => {
  return (
    <>
      <SelectService server={'4'} />
    </>
  );
};

export default Server4;
